import PropTypes from 'prop-types';

export const isUk = ({ code, pricingAreaCode }) => {
  if (!code || !pricingAreaCode) return false;

  const lowerCode = code.toLowerCase();
  const lowerPricingAreaCode = pricingAreaCode.toLowerCase();

  return lowerPricingAreaCode === 'gb' || lowerCode === '01' || lowerCode === '02';
};

export const isApprovedStudyArea = ({ code, pricingAreaCode }) => {
  if (!code || !pricingAreaCode) return false;

  const lowerCode = code.toLowerCase();
  const lowerPricingAreaCode = pricingAreaCode.toLowerCase();

  return (
    (lowerPricingAreaCode === 'eu' || lowerPricingAreaCode === 'ie') && !(lowerCode === '01' || lowerCode === '02')
  );
};

export const isRestOfWorld = ({ pricingAreaCode }) => {
  if (!pricingAreaCode) return false;

  const lowerPricingAreaCode = pricingAreaCode.toLowerCase();
  return lowerPricingAreaCode === 'oe';
};

export const isWales = ({ code }) => {
  if (!code) return false;

  const lowerCountryCode = code.toLowerCase();
  return lowerCountryCode === 'wa';
};

export const isIreland = ({ pricingAreaCode }) => pricingAreaCode?.toLowerCase() === 'ie';

isUk.propTypes = {
  code: PropTypes.string.isRequired,
  pricingAreaCode: PropTypes.string.isRequired,
};

isApprovedStudyArea.propTypes = {
  code: PropTypes.string.isRequired,
  pricingAreaCode: PropTypes.string.isRequired,
};

isRestOfWorld.propTypes = {
  pricingAreaCode: PropTypes.string.isRequired,
};

isWales.propTypes = {
  code: PropTypes.string.isRequired,
};

isIreland.propTypes = {
  pricingAreaCode: PropTypes.string.isRequired,
};
